import { render, staticRenderFns } from "./NewRevision.vue?vue&type=template&id=647965eb"
import script from "./NewRevision.vue?vue&type=script&lang=js"
export * from "./NewRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports